var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"content-parent"}},[_c('div',{attrs:{"id":"content-view"}}),(_vm.items)?_c('renderer',{attrs:{"result":_vm.items}}):_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }